import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DesignationDto } from './designation.dto';


export class DesignationResponseModel extends GlobalResponseObject{
    data?: DesignationDto;

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: DesignationDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}